// extracted by mini-css-extract-plugin
export var footerColumnFirst = "styles-module--footerColumnFirst--9dafe";
export var footerHeading = "styles-module--footerHeading--ae71f";
export var footerInner = "styles-module--footerInner--3c97b";
export var footerItem = "styles-module--footerItem--38d85";
export var footerLink = "styles-module--footerLink--cd68f";
export var footerLinkMobile = "styles-module--footerLinkMobile--81dc5";
export var footerLinkSocial = "styles-module--footerLinkSocial--898a5";
export var logo = "styles-module--logo--be6d4";